import UnsupportedBrowserPage from './UnsupportedBrowserPage.container'

export default UnsupportedBrowserPage
